export default __webpack_public_path__ + "static/media/radio.781d2e03.png";